import { Outlet, useParams, useLocation } from "react-router-dom";
import { useSectionNavLinks } from "../_utils";
import AppLayout from "@/layouts/AppLayout";
import ErrorBoundary from "@/components/ErrorBoundary";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";

export default function SectionPeopleLayout() {
  const { sectionId } = useParams();
  const { pathname } = useLocation();
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const navLinks = useSectionNavLinks(sectionId);
  const isSettings = pathname.endsWith("/settings");

  if (!sectionId) {
    return (
      <div data-testid="error">
        <ErrorBoundary variant="inline" title="Invalid Page Access" message="Section ID not found" />
      </div>
    );
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile && !isSettings && (
        <Breadcrumb
          compactOnly
          compactTitle="People"
          backLink={{ to: "/sections/:sectionId", params: { sectionId } }}
        />
      )}
      <Outlet />
    </AppLayout>
  );
}
